import { object, string, array } from "prop-types"
import { Box, StackView } from "@planningcenter/tapestry-react"
import { sessionsDateFormatter } from "../utils/dateFormatter"

const ShowSessions = ({ sessions }) => {
  return (
    <StackView spacing={1}>
      {sessions.map((session, index) => (
        <div key={`show-sessions-${index}`}>
          <Session session={session} />
        </div>
      ))}
    </StackView>
  )
}

ShowSessions.propTypes = {
  sessions: array
}

const Session = ({ session }) => {
  const formattedDate = sessionsDateFormatter(session.showsAt, session.hidesAt)
  return (
    <Box className="drawer" padding={1}>
      <span>{formattedDate}</span>
    </Box>
  )
}

Session.propTypes = {
  session: object,
  time: string
}

export default ShowSessions
